export default __webpack_public_path__ + "assets/front/scss/affichage-table.931f5824c9d3755b27a63f7e5a056170.css";